import SpottyCat from './SpottyCat';

export default SpottyCat;
